export default __webpack_public_path__ + "static/media/practice-test-7.d24bcec2.csv";